import api from './api';

export const getProfile = () =>
  api.get('/api/v1/settings/profile').then((r) => r.data.data);

export const updateProfile = (data) =>
  api.put('/api/v1/settings/profile', data).then((r) => r.data.data);

export const changePassword = (data) =>
  api.put('/api/v1/settings/password', data).then((r) => r.data);

export const getPractice = () =>
  api.get('/api/v1/settings/practice').then((r) => r.data.data);

export const updatePractice = (data) =>
  api.put('/api/v1/settings/practice', data).then((r) => r.data.data);

export const getAuditLog = (params) =>
  api.get('/api/v1/settings/audit-log', { params }).then((r) => r.data.data);

export const totpSetup = () =>
  api.post('/api/v1/settings/totp/setup').then((r) => r.data.data);

export const totpEnable = (data) =>
  api.post('/api/v1/settings/totp/enable', data).then((r) => r.data);

export const totpDisable = (password) =>
  api.delete('/api/v1/settings/totp', { data: { password } }).then((r) => r.data);

export const regenerateBackupCodes = (password) =>
  api.post('/api/v1/settings/totp/backup-codes/regenerate', { password }).then((r) => r.data);

export const getStripeConnectStatus = () =>
  api.get('/api/v1/stripe-connect/status').then((r) => r.data.data);

export const initiateStripeOnboarding = () =>
  api.post('/api/v1/stripe-connect/onboard').then((r) => r.data.data);

export const disconnectStripe = () =>
  api.delete('/api/v1/stripe-connect/disconnect').then((r) => r.data);

export const getStripeDashboardLink = () =>
  api.post('/api/v1/stripe-connect/dashboard-link').then((r) => r.data.data);

export const completeOnboarding = () =>
  api.post('/api/v1/settings/onboarding/complete').then((r) => r.data.data);

export const acceptBAA = (signerName) =>
  api.post('/api/v1/settings/baa/accept', { signerName }).then((r) => r.data.data);

export const enableWidget = (widgetSettings) =>
  api.post('/api/v1/settings/widget/enable', { widgetSettings }).then((r) => r.data.data);

export const regenerateWidgetToken = () =>
  api.post('/api/v1/settings/widget/regenerate-token').then((r) => r.data.data);
